import bankChina from '../../banksPNG/bankChina.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoOfChinaIcon = ({
	width = '17',
	height = '17',
	alt = 'Banco de China',
}: IconProps) => <img src={bankChina} width={width} height={height} alt={alt} />;
